'use client';

import React__default, { useState, useEffect, useMemo } from 'react';
import { CheckBoxWrapper, CheckBoxDiv, Label, LabelText, SubLabel } from './CheckBox.css.js';

var CheckBox = function (props) {
    var _a = props.state, state = _a === void 0 ? 'none' : _a, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.labelRightMargin, labelRightMargin = _c === void 0 ? 60 : _c, label = props.label, _d = props.subLabel, subLabel = _d === void 0 ? '' : _d, _e = props.tabIndex, tabIndex = _e === void 0 ? 0 : _e, onCheckChange = props.onCheckChange, onFocus = props.onFocus, disabled = props.disabled, _f = props.isShowTooltip, isShowTooltip = _f === void 0 ? false : _f, customLabel = props.customLabel, _g = props.hiddenCheckBox, hiddenCheckBox = _g === void 0 ? false : _g;
    var _h = useState(state), checkState = _h[0], setCheckState = _h[1];
    var handleClickCheck = function () {
        if (disabled) {
            return;
        }
        var checkStateChange = checkState;
        switch (checkState) {
            case 'none':
                checkStateChange = 'checked';
                break;
            case 'half':
                checkStateChange = 'none';
                break;
            case 'checked':
            default:
                checkStateChange = 'none';
                break;
        }
        setCheckState(checkStateChange);
        onCheckChange && onCheckChange(checkStateChange);
    };
    var handleEnter = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            handleClickCheck();
        }
    };
    useEffect(function () {
        setCheckState(state);
    }, [state]);
    var getCustomLabel = useMemo(function () {
        if (customLabel) {
            return typeof customLabel === 'function' ? customLabel(checkState) : customLabel;
        }
        return null;
    }, [checkState, customLabel]);
    return (React__default.createElement(CheckBoxWrapper, { hiddenCheckBox: hiddenCheckBox, title: isShowTooltip ? label : '', onClick: handleClickCheck, onFocus: onFocus, disabled: disabled, style: style, "data-check-state": checkState },
        !hiddenCheckBox ? React__default.createElement(CheckBoxDiv, { state: checkState, onKeyDown: handleEnter, tabIndex: tabIndex }) : null,
        getCustomLabel || (React__default.createElement(Label, null,
            React__default.createElement(LabelText, { labelRightMargin: labelRightMargin }, label),
            subLabel && React__default.createElement(SubLabel, null, subLabel)))));
};

export { CheckBox as default };
//# sourceMappingURL=index.js.map
